import * as React from 'react';
import { TooltipDesktop, InlineText2 } from '@cian/ui-kit';
import classNames from 'clsx';

import * as styles from './styles.css';

export interface IReliableLabelTooltipProps {
  icon?: React.ReactNode;
  text: React.ReactNode;
  tooltipText: string;
  styleName?: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableLabel({ icon, text, tooltipText, styleName, onClick }: IReliableLabelTooltipProps) {
  return (
    <TooltipDesktop
      placement="top"
      title={
        <div className={styles['tooltip']}>
          <InlineText2 color="white_100">{tooltipText}</InlineText2>
        </div>
      }
    >
      <div
        className={classNames(styles['container'], styleName && styles[styleName])}
        onClick={onClick}
        data-testid="ReliableLabel"
      >
        {icon && <div className={styles['icon']}>{icon}</div>}
        {text}
      </div>
    </TooltipDesktop>
  );
}
